/**
 * Created by quikr on 11/4/16.
 */
import toastr from "toastr";
import ApiCli from "../../helpers/ApiCli";
import {beginAjaxCall} from "../actions/ajaxStatusActions";
import moment from "moment";

let AjaxCall = new ApiCli();
function parseDate(date) {
  return parseInt(date.toISOString().substr(8, 2));
}


export function getLeaveBalanceSuccess(balance) {
  return {type: 'GET_LEAVE_BALANCE_SUCCESS', balance};
}

export function getOptionalLeavesSuccess(optional) {
  return {type: 'GET_OPTIONAL_LEAVES_SUCCESS', optional};
}

export function getLeaveHistorySuccess(history) {
  return {type: 'GET_LEAVE_HISTORY_SUCCESS', history};
}
export function getTeamLeaveSuccess(team) {
  return {type: 'GET_TEAM_LEAVE_SUCCESS', team};
}
export function getTeamLeaveHistorySuccess(teamHistory) {
  return {type: 'GET_TEAM_LEAVE_HISTORY_SUCCESS', teamHistory};
}
export function getTeamWeeklySuccess(teamWeekly) {
  return {type: 'GET_TEAM_WEEKLY_SUCCESS', teamWeekly}
}
export function getLeaveLedgerSuccess(ledger) {
  return {type: 'GET_LEAVE_LEDGER_SUCCESS', ledger}
}

export function getLeaveBalance() {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let call1 = AjaxCall.asyncAction('/leaveBalance', 'get', null, null, dispatch);
    call1.then((response)=> {
      const balance = response.data.data;
      dispatch(getLeaveBalanceSuccess(balance));
    }).catch((error) => {
      console.log(error);
    });
  }
}

export function getOptionalLeaves() {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let call1 = AjaxCall.asyncAction('/leave/optional', 'get', null, null, dispatch);
    call1.then((response)=> {

      const optional = response.data.data;
      console.log(optional);
      console.log(response.data.data);
      dispatch(getOptionalLeavesSuccess({optional: optional}));
    }).catch((error) => {
      console.log(error);
    });
  }
}


export function getLeaveHistory() {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let call1 = AjaxCall.asyncAction('/leave/history', 'get', null, null, dispatch);
    call1.then((response)=> {
      const history = response.data.data;
      dispatch(getLeaveHistorySuccess({history: history}));
    }).catch((error) => {
      console.log(error);
    });
  }

}

export function getTeamLeave() {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let call1 = AjaxCall.asyncAction('/team/leave', 'get', null, null, dispatch);
    call1.then((response)=> {
      const team = response.data.data;
      dispatch(getTeamLeaveSuccess({team: team}));
    }).catch((error) => {
      console.log(error);
    });
  }


}


export function applyLeave(request) {
  return function (dispatch) {

    console.log(request);
    let call1 = AjaxCall.asyncAction('/leave/apply', 'post', null, {data: request}, dispatch);
    call1.then((response)=> {
      toastr.success("Leave Successfully Applied");
      dispatch(beginAjaxCall());
      let call2 = AjaxCall.asyncAction('/leaveBalance', 'get', null, null, dispatch);
      call2.then((response)=> {
        const balance = response.data.data;
        dispatch(getLeaveBalanceSuccess(balance));
      }).catch((error) => {
        console.log(error);
      });

      dispatch(beginAjaxCall());
      let call3 = AjaxCall.asyncAction('/leave/ledged/view', 'get', null, null, dispatch);
      call3.then((response) => {

        dispatch(getLeaveLedgerSuccess({ledger: response.data.data}));

      }).catch((error)=> {
        console.log(error);
      });

    }).catch((error) => {
      console.log(error.response.data);

    });
  }
}
export function cancelLeave(request) {
  return function (dispatch) {
    console.log(request);

    let call1 = AjaxCall.asyncAction('/cancel/leave', 'post', null, {data: request}, dispatch);
    call1.then((response)=> {
      toastr.success("Leave " + request.leaveProcess);
      dispatch(beginAjaxCall());
      let call2 = AjaxCall.asyncAction('/leave/history', 'get', null, null, dispatch);
      call2.then((response)=> {
        const history = response.data.data;

        dispatch(getLeaveHistorySuccess({history: history}));
      }).catch((error) => {
        console.log(error);
      });
    }).catch((error) => {
      console.log(error);
    });
  }
}

export function rejectLeave(request) {
  return function (dispatch) {
    console.log(request);

    let call1 = AjaxCall.asyncAction('/team/leave', 'post', null, {data: request}, dispatch);
    call1.then((response)=> {
      toastr.success("Leave " + request.leaveProcess);

      dispatch(beginAjaxCall());

      let call2 = AjaxCall.asyncAction('/leave/history', 'get', null, null, dispatch);
      call2.then((response)=> {
        const history = response.data.data;
        dispatch(getLeaveHistorySuccess({history: history}));
      }).catch((error) => {
        console.log(error);
      });

      dispatch(beginAjaxCall());
      let call3 = AjaxCall.asyncAction('/team/leave', 'get', null, null, dispatch);
      call3.then((response)=> {
        const team = response.data.data;
        dispatch(getTeamLeaveSuccess({team: team}));
      }).catch((error) => {
        console.log(error);
      });


    }).catch((error) => {
      console.log(error);
    });
  }
}

export function getTeamLeaveHistory(search, no = 0) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let dateStart = search.startDate;
    let dateEnd = search.endDate;
    let endDate;
    let fromDate;
    console.log(search);
    let request = {
      from: search.startDate,
      to: search.endDate,

      indirect: search.indirect,
      vertical: search.vertical
    }
    console.log(JSON.stringify(request));
    let call1 = AjaxCall.asyncAction('/team/leave/history/_search?q=' + JSON.stringify(request), 'get', null, null, dispatch);
    call1.then((response) => {

      dispatch(getTeamLeaveHistorySuccess({teamHistory: response.data.data}));

    }).catch((error)=> {
      console.log(error);
    });

  }
}
export function loadDefault() {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    dispatch(getTeamWeeklySuccess({teamWeekly: []}));
  }
}
export function getTeamWeeklyDetails(search, no = 0) {
  return function (dispatch) {
    dispatch(beginAjaxCall());

    let request = {
      from: moment(search.startDate).format(),
      to: moment(search.endDate).format(),

      indirect: search.indirect,
      vertical: search.vertical
    }
    console.log(request);
    let call1 = AjaxCall.asyncAction('/team/leave/weekly/details/_search?q=' + JSON.stringify(request), 'get', null, null, dispatch);
    call1.then((response) => {

      dispatch(getTeamWeeklySuccess({teamWeekly: response.data.data}));

    }).catch((error)=> {
      console.log(error);
    });

  }
}
export function getLeaveLedger() {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let call1 = AjaxCall.asyncAction('/leave/ledged/view', 'get', null, null, dispatch);
    call1.then((response) => {
      debugger;
      dispatch(getLeaveLedgerSuccess({ledger: response.data.data}));

    }).catch((error)=> {
      console.log(error);
    });


  }

}




/** WEBPACK FOOTER **
 ** ./src/redux/actions/leaveActions.js
 **/